export function getRandomString(s: number) {
  if (s % 2 === 1) {
    throw new Error('Only even sizes are supported')
  }

  if (s < 0) {
    throw new Error('Only positive sizes are supported')
  }

  const buf = new Uint8Array(s / 2)
  crypto.getRandomValues(buf)
  let ret = ''

  for (const element of buf) {
    ret += `0${element.toString(16)}`.slice(-2)
  }

  return ret
}
